// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"25":"18917fce","90":"91a63bc7","134":"63715ff8","290":"549db03d","583":"d4f69c9b","670":"9e96d02f","685":"0bc11a57","722":"b7a792a6"}[chunkId] + ".chunk.js";
};